import {ShowerHeadTypes, ShowerHandTypes, createParentPositions} from "../../constants";
import ShowerCommon from "../showerNew/showerCommon";

export default class HandShowerKit extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hand_shower_kit';
    this.partName = 'Hand Shower Kit';
    this.translateId = "visualizer.bathroom.shower.hand_shower_kit";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (!Array.isArray(dbFeature.metaData["MountType"])) {
      dbFeature.metaData["MountType"] = ["0"]
    }
    return super.load(dbFeature);
  }

  handleClick() {
    const featureGroup = this.getParent();
    const showerParent = featureGroup.getParent();
    if (featureGroup.hideLayerCondition()) {
      // if (showerParent.shower_head_type !== ShowerHeadTypes.shower_fixture && ) {
      //
      // }
      // showerParent.setShowerHeadType(ShowerHeadTypes.shower_fixture);
      showerParent.setShowerHandType(ShowerHandTypes.hand_shower_kit);
    }
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    const showerTubComboParent = showerParent.layout.parts["Shower Tub Combo"];
    if (showerTubComboParent?.showerTubComboIsActive && showerTubComboParent.bottomTub === "walk_in_tub") {
      return true // QCDES-8175
    }
    return (showerParent.shower_head_type !== ShowerHeadTypes.shower_arm
        && showerParent.shower_head_type !== ShowerHeadTypes.shower_fixture)
      || showerParent.shower_hand_type !== ShowerHandTypes.hand_shower_kit
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    //Hand Shower Kit should be displayed with the fixtures that have MountType: 0
    if (showerParent.showerFixture && !showerParent.showerFixture.disabled && showerParent.showerFixture.activeFeature
      && showerParent.showerFixture.activeFeature.metaData["MountType"]) {
      conditions.push({
        propName: "MountType",
        propValue: showerParent.showerFixture.activeFeature.metaData["MountType"]
      })
    }
    return conditions
  }

  matchesMetaForCondition(...props) {
    const [name] = props;
    if (name === "MountType" && Array.isArray(this.metaData["MountType"]) && this.metaData["MountType"].includes("0")) {
      return true
    }
    return super.matchesMetaForCondition(...props);
  }

  canDisplayDemoPoint() {
    return this.getParent().shower_head_type !== ShowerHeadTypes.shower_head_bundle
  }

  showLayerPositionsModal() {
    return true
  }

}
